/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h } from './index-ef0fa435.js';
import { s as sortBy, f as forOwn } from './sortBy-b73ee1ae.js';
import { g as groupBy } from './groupBy-0317d4fa.js';
import './_baseMap-fff80b84.js';
import './_getAllKeys-4fdbf8d3.js';
import './_isIndex-11d39322.js';
import './isLength-dd14023c.js';
import './isObjectLike-0c552769.js';
import './global-3053f997.js';
import './isObject-036bb226.js';
import './isArray-ba17b1aa.js';
import './_getTag-35542633.js';
import './_hasPath-4e6157fe.js';
import './_setToString-ddc63fce.js';
import './_defineProperty-f2b25ce4.js';
import './_baseAssignValue-0c712625.js';

const areaCss = "slot-fb[hidden],slot[hidden]{display:initial !important}.details{padding:3rem 0 0 0}.details lar-button-group{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.actions{min-height:60px}lar-list-item{background-color:var(--lar-background-color-step-100, #1a1a1a) !important;color:var(--lar-text-color, #fff) !important}.spacer{margin-top:1.5rem;margin-bottom:1.5rem}.circle{background-color:var(--lar-background-color-step-200, #333333) !important;border-radius:50%;display:inline-block;padding:0.5rem;width:2rem;height:2rem;margin-right:1rem}.circle lar-icon{display:block;width:100%;height:100%}.zone-list h4{margin:0;padding:0}.zone-list h4 lar-badge{margin-top:0.2rem;margin-right:0.3rem;font-weight:normal}.zone-selectors{text-align:center;margin-bottom:1rem}.zone-selectors lar-button{margin:0.2rem}.zone-list lar-badge{margin-top:0.3rem}lar-button.zone-group{--lar-button-font-size-small:.95rem;--lar-button-padding-top-small:.4rem;--lar-button-padding-bottom-small:.4rem;--lar-button-padding-left-small:.4rem;--lar-button-padding-right-small:.4rem}.center{text-align:center}";

const AreaZones = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.zones = undefined;
  }
  render() {
    const zones = [];
    const sortedZones = sortBy(JSON.parse(this.zones), 'group');
    const groupedZones = groupBy(sortedZones, 'group');
    forOwn(groupedZones, (groupedZonesOwn, group) => {
      zones.push(h("lar-list-header", null, h("lar-translate", { t: group })));
      sortBy(groupedZonesOwn, 'name').forEach(zone => {
        let color = 'success';
        if (zone.state === 'open') {
          color = 'tertiary';
        }
        if (zone.state === 'short_circuit') {
          color = 'warning';
        }
        if (zone.state === 'open_circuit') {
          color = 'danger';
        }
        zones.push(h("lar-list-item", null, h("div", { slot: "start", class: "circle" }, h("lar-icon", { icon: zone.type, color: color })), h("div", null, h("h4", null, h("lar-translate", { t: zone.name })), h("lar-badge", { color: color }, h("lar-translate", { t: 'area.zone_state.' + zone.state })), zone.overridden &&
          h("span", null, "\u00A0", h("lar-badge", { color: "danger" }, h("lar-translate", { t: 'area.zone_state.bypassed' }))))));
      });
    });
    return h("div", { class: "zone-list" }, zones);
  }
};
AreaZones.style = areaCss;

export { AreaZones as lar_area_zones };

//# sourceMappingURL=lar-area-zones.entry.js.map